import { API } from '@config';
import { CommunitySafetyIndoorTable } from '@src/types/CommunitySafetyIndoor';

export const getCommunitySafetyIndoor = async () => {
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(`${API}/api/community-safety-indoors?populate=File&sort=id%3Adesc`, options);
  const data: CommunitySafetyIndoorTable = await response.json();

  return data;
};
